import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { INVESTIGATION_HISTORY } from "../investigation.constants";
import type { TInvestigationHistoryFilter } from "../investigation.models";

interface IInvestigationHistoryFiltersProps {
  filter: TInvestigationHistoryFilter;
  counts: Record<TInvestigationHistoryFilter, number>;
  onChange: (filter: TInvestigationHistoryFilter) => void;
}

/** All / Driving / Ride changes / Supplier / Bulk jobs, each with its row count. */
export const InvestigationHistoryFilters: FC<
  IInvestigationHistoryFiltersProps
> = ({ filter, counts, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="history-filters">
      {INVESTIGATION_HISTORY.filters.map(option => (
        <button
          key={option}
          type="button"
          className="history-filter"
          aria-pressed={filter === option}
          onClick={() => onChange(option)}
        >
          {`${t(`${INVESTIGATION_HISTORY.i18nKey}.filters.${option}`)} (${counts[option]})`}
        </button>
      ))}
    </div>
  );
};
